var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
const SvgComponent = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 24,
  height: 24,
  viewBox: "0 0 24 24",
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M18.0119 5.72061L22.2012 12L18.0119 18.2794L18.0109 18.2809C17.9659 18.3486 17.9049 18.404 17.8333 18.4422C17.7617 18.4804 17.6817 18.5003 17.6005 18.5H17.5969H3.75C3.61739 18.5 3.49021 18.4473 3.39645 18.3536C3.30268 18.2598 3.25 18.1326 3.25 18V6.00001C3.25 5.8674 3.30268 5.74022 3.39645 5.64646C3.49021 5.55269 3.61739 5.50001 3.75 5.50001L17.5969 5.50002L17.6005 5.5C17.6817 5.49971 17.7617 5.51957 17.8333 5.55781C17.9049 5.59605 17.9659 5.65146 18.0109 5.71909L18.0119 5.72061Z",
  stroke: "#003F76",
  strokeWidth: 2
})));
export default __webpack_public_path__ + "static/media/tag.6f776cb4.svg";
export { SvgComponent as ReactComponent };